import { useQuery } from '@tanstack/react-query'
import api from '@/api/axiosApi'
import type { UserRead } from '@/api/shares'

interface PaginationMeta {
  skip: number
  limit: number
  total: number
  has_more: boolean
}

interface PaginatedUsersResponse {
  data: UserRead[]
  pagination: PaginationMeta
}

interface ManagerSearchParams {
  search?: string
}

/**
 * Hook to fetch managers for reviewer selection.
 * Uses the /admin/users endpoint with role=MANAGER filter.
 */
export function useManagerSearch(params: ManagerSearchParams = {}) {
  const { search } = params

  return useQuery({
    queryKey: ['managers', search],
    queryFn: async () => {
      const response = await api.get<PaginatedUsersResponse>('/admin/users', {
        params: {
          role: 'MANAGER',
          search: search || undefined,
          limit: 100,
        },
      })
      return response.data.data
    },
  })
}
